// extracted by mini-css-extract-plugin
export var box = "Location-module--box--d28e1";
export var btn = "Location-module--btn--3ab28";
export var map = "Location-module--map--84a85";
export var text = "Location-module--text--7d8b0";